import { useTranslation } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import ChevronLeftIcon from '~/components/Icons/svgs/ChevronLeftIcon'
import ChevronRightIcon from '~/components/Icons/svgs/ChevronRightIcon'

export default function CalendarMonthNavigation({
  onNextMonthClick,
  onPrevMonthClick,
  className,
  classNext,
  classPrevious,
}: {
  onNextMonthClick: () => void
  onPrevMonthClick: () => void
  className?: string
  classNext?: string
  classPrevious?: string
}): React.ReactElement {
  const { t } = useTranslation('generics')

  return (
    <div className={`flex justify-between ${className || ''}`}>
      <button className={`flex items-center space-x-2 font-semibold ${classPrevious || ''}`} onClick={onPrevMonthClick}>
        <SVGIcon icon={ChevronLeftIcon} pathClassName="text-purple" size={14} />
        <span>{t('previous')}</span>
      </button>

      <button className={`flex items-center space-x-2 font-semibold ${classNext || ''}`} onClick={onNextMonthClick}>
        <span>{t('next')}</span>
        <SVGIcon icon={ChevronRightIcon} pathClassName="text-purple" size={14} />
      </button>
    </div>
  )
}
